import script from "./Pago.vue?vue&type=script&setup=true&lang=js"
export * from "./Pago.vue?vue&type=script&setup=true&lang=js"

import "./Pago.vue?vue&type=style&index=0&id=4ba2c1e8&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba2c1e8"]])

export default __exports__